import { render, staticRenderFns } from "./BFStep3Payment.vue?vue&type=template&id=7e3c86e9"
import script from "./BFStep3Payment.vue?vue&type=script&lang=js"
export * from "./BFStep3Payment.vue?vue&type=script&lang=js"
import style0 from "./BFStep3Payment.vue?vue&type=style&index=0&id=7e3c86e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports